import { PaginationOptions } from 'types';

export const DEFAULT_PAGINATION: PaginationOptions = {
  page: 1,
  take: 10,
};
